<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >

      <v-flex mb-4>
        <v-flex v-if="!myprofile.qualified_profile">
            <h1 class="display-2 font-weight-bold mb-3" v-if="!myprofile.qualified_profile">
              Account Setup
            </h1>
            <br/>
            Please complete account setup
            <br/>
            다음의 사항들을 처리하여 계정 설정을 마무리 해주시기 바랍니다.

        </v-flex>
        <h1 class="display-2 font-weight-bold mb-3" v-else>
          Home
        </h1>
        <div v-if="!qualified_profile">
            <v-btn to="/profile/email_add" class="subheading font-weight-regular" v-if="!myprofile.qualified_profile_emails">
              <v-icon color='red'>fas fa-exclamation-circle</v-icon> &nbsp; 이메일 등록 Verify Email
            </v-btn>
            <div v-else>
                Email Verified :)
            </div>

            <v-btn to="/profile" class="subheading font-weight-regular" v-if="!myprofile.qualified_basic_profile">
              <v-icon color='red'>fas fa-exclamation-circle</v-icon> &nbsp; 프로필 등록 Enter Name/Profile
            </v-btn>
            <div v-else>
                Profile Complete :)
            </div>
        </div>
        <div v-if="qualified_profile">
            Your basic profile is complete.  
            <br/>
	    프로필 등록이 완료되었습니다.
            <br/>
            You can now apply for events.
            <br/>
	    이벤트 신청이 가능합니다. 
            <br/>
            <v-btn to="/events">행사 신청하기 Event Registration</v-btn> 
        </div>
      </v-flex>


<!--
      <v-flex
        xs12
        mb-5
      >
        <h2 class="headline font-weight-bold mb-3">Debug</h2>

        <v-layout justify-center>
        <small>
        {{ this.clientname() }}
        <br/>
        {{ this.apiurl() }}
        </small>
        </v-layout>
      </v-flex>
      -->

    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';
export default {
  props: [''],
  data: () => ({}),
  computed: {
    ...mapState(['myprofile']),
    qualified_profile() {
      return this.myprofile.qualified_profile;
    },
  },
  methods: {
    clientname() {
      return process.env.VUE_APP_TAPTAGS_CLIENT_NAME;
    },
    apiurl() {
      return process.env.VUE_APP_TAPTAGS_API_URL;
    },
  },
};
</script>

<style scoped>
.v-btn {
  min-width: 80%;
}
</style>
